export default __webpack_public_path__ + "static/media/entrega@3x.da06bc06.png";